import { useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import Button from 'components/UI/Button'

import { testPassedStatuses } from 'constants'

import {
  setActiveCategory,
  setActiveCategoryIndex,
  setStep,
} from 'routing/fetchingfunction/user/user.action'

import testsFailed from 'assets/image/tests-failed.png'
import testsPassed from 'assets/image/tests-passed.png'
import testsFlagged from 'assets/image/Alart.png'
import allTestsAreFailed from 'assets/image/all-tests-are-failed.svg'

const TestResults = ({ passedStatus, testName, onContinue, resumeStream }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  // TODO compare lastPassedCategory index and selectedCategories.length - 1 to know what is the next step
  const { activeCategoryIndex, selectedCategories, passedTests } = useSelector(
    (state) => state.user
  )

  const areAllTestsFailed =
    passedTests.every((test) => test.test.is_passed === false && test.test.result !== 'pending') &&
    passedTests.length === selectedCategories.length
  //  &&   passedTests.length !== 1

  const singularTestFailed =
    passedTests.length === 1 &&
    passedTests[0].test.is_passed === false &&
    passedTests[0].test.result !== 'pending'

  const lastTest = activeCategoryIndex === selectedCategories.length - 1

  const handleContinue = () => {
    console.log(areAllTestsFailed, 'all test failed')
    // if (areAllTestsFailed) {
    //   dispatch(setStep(1))

    //   setTimeout(() => {
    //     navigate('/tutor')
    //   }, 0)

    //   return
    // }

    if (activeCategoryIndex === selectedCategories.length - 1) {
      onContinue(1)
    } else {
      onContinue(-1)

      dispatch(setActiveCategoryIndex(activeCategoryIndex + 1))
      dispatch(setActiveCategory(selectedCategories[activeCategoryIndex + 1]))
      resumeStream()
    }
  }

  const resultsContent = useMemo(() => {
    switch (passedStatus) {
      case testPassedStatuses.PASSED_ALL:
        return {
          title: 'Congratulations!',
          description: 'All Tests have been passed successfully!',
          nextStepText: 'Now you’re able to setup your class.',
          nextStep: 'Continue',
          passed: true,
          image: testsPassed,
        }
      case testPassedStatuses.PASSED_PARTIAL:
        return {
          title: 'Congratulations!',
          description: `${testName ? `${testName} ` : ''}Test Successfully Passed!`,
          nextStepText: 'Let’s continue to the next test.',
          nextStep: 'Continue',
          // nextStep: 'Continue to Next Test',
          passed: true,
          image: testsPassed,
        }
      case testPassedStatuses.FAILED_ALL:
        return {
          title: `Oops!`,
          description: `You Failed All Category Tests.`,
          nextStepText: 'You can try this test again after 30 days.',
          nextStep: 'Continue',
          passed: false,
          image: testsFailed,
        }
      case testPassedStatuses.FAILED_PARTIAL:
        return {
          title: `Unfortunately, you have failed the${testName ? ` ${testName}` : ''} test.`,
          nextStepText:
            'You can try this test again in 30 days. Let’s continue and complete the remaining tests.',
          nextStep: 'Continue',

          passed: false,
          image: testsFailed,
        }
      case testPassedStatuses.CANCELED_PARTIAL:
        return {
          title: `You have failed the${testName ? ` ${testName}` : ''} test.Test was canceled`,
          nextStepText:
            'You can try this test again in 30 days. Let’s continue and complete the remaining tests.',
          nextStep: 'Continue',

          passed: false,
          image: testsFailed,
        }
      case testPassedStatuses.FLAGGED:
        return {
          title: `Your  ${testName ? ` ${testName}` : 'Last'} test was flagged by our proctoring system.`,
          nextStepText:
            'We’ll review it and let you know the result as soon as possible. Thanks for your patience!',
          nextStep: 'Continue',

          passed: false,
          image: testsFlagged,
        }
    }
  }, [passedStatus, testName])

  console.log(passedStatus, resultsContent, passedTests)

  return (
    <div className="flex flex-col items-center justify-start !text-white-50">
      {areAllTestsFailed && 'You Failed All Tests.'}
      <div className="max-w-xl">
        <h3
          className={`${singularTestFailed ? 'text-4xl' : areAllTestsFailed ? 'text-5xl' : 'text-4xl'} text-center font-semibold`}
        >
          {singularTestFailed
            ? `${testName} Test Failed`
            : areAllTestsFailed
              ? 'We are sorry you have failed all test.'
              : resultsContent.title}
        </h3>

        {areAllTestsFailed ? (
          <h4 className="!mt-3 font-medium">
            We will send an email in 30 days so you can take the test again.
          </h4>
        ) : (
          resultsContent.description && (
            <h4 className="text-2xl  !mb-3">{resultsContent.description}</h4>
          )
        )}

        {!areAllTestsFailed && !lastTest && (
          <p className="!my-4 text-center">{resultsContent.nextStepText}</p>
        )}
      </div>

      {areAllTestsFailed ? (
        <div className="my-[50px] ">
          <img className="block" src={allTestsAreFailed} alt="All tests are failed" />
        </div>
      ) : (
        <div className="!mb-5 my-[50px] ">
          <img className="block" src={resultsContent.image} alt="Passed" />
        </div>
      )}

      <Button
        variant="primary"
        onClick={handleContinue}
        className="shadow-button-second shadow border !border-gray-600/30 max-w-lg w-full"
      >
        {areAllTestsFailed ? 'Finish Registration' : resultsContent?.nextStep}
      </Button>
    </div>
  )
}

export default TestResults
